import { type BookmakersConfig } from '@cx-modules/types';

import { type SectionProps } from '~/components/BettingInsights/components/ResultTable';
import type ODDS_FORMAT from '~/enums/odds_format';
import { type RequestContext } from '~/types/RequestContext';

import { BettingInsightsComponent } from '../BettingInsightsConfiguration';
import { type BettingInsightsContent, type EsIndex } from '../types';

import { type BettingInsightsUI, type StyleSheet } from './BettingInsightsUI';

export interface BettingInsightsTableBodyConfig<
	TIndex extends EsIndex,
	TContent = BettingInsightsContent<TIndex>,
> {
	render: (props: {
		bookmakers: BookmakersConfig;
		content: TContent;
		label: string;
		oddsFormat: ODDS_FORMAT;
		resultIndex: number;
		sectionProps: SectionProps;
		styles: StyleSheet;
		table: BettingInsightsUI<TIndex>['card']['table'];
	}) => React.ReactNode;
}

export class BettingInsightsTableBody<
		TIndex extends EsIndex,
		TContent = BettingInsightsContent<TIndex>,
	>
	extends BettingInsightsComponent
	implements BettingInsightsTableBodyConfig<TIndex, TContent>
{
	render: (props: {
		bookmakers: BookmakersConfig;
		content: TContent;
		label: string;
		oddsFormat: ODDS_FORMAT;
		resultIndex: number;
		sectionProps: SectionProps;
		styles: StyleSheet;
		table: BettingInsightsUI<TIndex>['card']['table'];
	}) => React.ReactNode;

	constructor({
		render,
		...requestContext
	}: BettingInsightsTableBodyConfig<TIndex, TContent> & RequestContext) {
		super(requestContext);
		this.render = render;
	}

	static withContext<
		TIndex extends EsIndex,
		TContent = BettingInsightsContent<TIndex>,
	>(
		requestContext: RequestContext,
		config: BettingInsightsTableBodyConfig<TIndex, TContent>,
	) {
		return new BettingInsightsTableBody<TIndex, TContent>({
			...requestContext,
			...config,
		});
	}
}
